import classNames from "classnames";
import React from "react";
import "./PopupRow.scss";

export function PopupRow({ className = "", children }) {
  return (
    <div className={classNames(["popup__row", className])}>{children}</div>
  );
}
